import React from 'react';
import { getColumnWidthClass } from '../utils';
import { isContainerField } from '../constants/fieldTypeGroups';
import { FieldActions } from './FieldActions';
import { COUNTRY_CODES } from '../PropertiesPanel/CountryCodesList';
import { CURRENCIES } from '../PropertiesPanel/CurrenciesList';

/**
 * Renders the appropriate input for preview based on field type
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const renderFieldInput = function (field) {
  let allFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  switch (field.type) {
    case 'textarea':
      return /*#__PURE__*/_jsx("textarea", {
        className: "preview-control",
        placeholder: field.placeholder,
        disabled: true,
        rows: 3
      });
    case 'select':
      return /*#__PURE__*/_jsxs("select", {
        className: "preview-control",
        disabled: true,
        multiple: field.multiselect || false,
        size: field.multiselect ? Math.min((field.options || []).length || 3, 5) : undefined,
        children: [/*#__PURE__*/_jsx("option", {
          children: field.placeholder || 'Select an option'
        }), field.options?.map((opt, i) => /*#__PURE__*/_jsx("option", {
          value: opt.value,
          children: opt.label
        }, i))]
      });
    case 'radio':
      return /*#__PURE__*/_jsx("div", {
        className: "preview-radio-group",
        children: field.options?.map((opt, i) => /*#__PURE__*/_jsxs("div", {
          className: "preview-radio-item",
          children: [/*#__PURE__*/_jsx("input", {
            type: "radio",
            disabled: true
          }), " ", opt.label]
        }, i))
      });
    case 'checkbox':
      return /*#__PURE__*/_jsx("div", {
        className: "preview-checkbox-group",
        children: field.options?.map((opt, i) => /*#__PURE__*/_jsxs("div", {
          className: "preview-checkbox-item",
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            disabled: true
          }), " ", opt.label]
        }, i))
      });
    case 'color':
      return /*#__PURE__*/_jsx("input", {
        type: "color",
        className: "preview-control preview-color-input",
        value: "#000000",
        disabled: true
      });
    case 'signature':
      return /*#__PURE__*/_jsxs("div", {
        className: "preview-signature-container signature-preview-container",
        children: [/*#__PURE__*/_jsx("canvas", {
          width: 400,
          height: 100,
          className: "signature-preview-canvas",
          disabled: true
        }), /*#__PURE__*/_jsx("div", {
          className: "signature-preview-label",
          children: "Signature Pad"
        })]
      });
    case 'currency':
      const currency = field.currency || 'USD';
      const selectedCurrency = CURRENCIES.find(c => c.code === currency) || CURRENCIES[0];
      const currencyEditable = field.currencyEditable !== false;
      return /*#__PURE__*/_jsx("select", {
        className: "preview-control",
        disabled: !currencyEditable,
        children: /*#__PURE__*/_jsxs("option", {
          value: selectedCurrency.code,
          children: [selectedCurrency.code, " - ", selectedCurrency.name, " (", selectedCurrency.symbol, ")"]
        })
      });
    case 'price':
      const currencySymbol = field.currencySymbol || '$';
      const priceCurrencyEditable = field.currencyEditable !== false;
      return /*#__PURE__*/_jsxs("div", {
        className: "price-preview-container",
        children: [/*#__PURE__*/_jsx("input", {
          type: "text",
          className: "preview-control price-preview-input",
          placeholder: "0.00",
          disabled: true
        }), /*#__PURE__*/_jsx("select", {
          className: "preview-control price-preview-currency-select",
          disabled: !priceCurrencyEditable,
          children: /*#__PURE__*/_jsxs("option", {
            children: [currencySymbol, " USD"]
          })
        })]
      });
    case 'tel':
      const countryCode = field.countryCode || 'US';
      const selectedCountry = COUNTRY_CODES.find(c => c.code === countryCode) || COUNTRY_CODES[0];
      return /*#__PURE__*/_jsxs("div", {
        className: "phone-preview-container",
        children: [/*#__PURE__*/_jsx("select", {
          disabled: true,
          className: "phone-preview-country-select",
          children: /*#__PURE__*/_jsxs("option", {
            value: selectedCountry.code,
            children: [selectedCountry.flag, " ", selectedCountry.dialCode]
          })
        }), /*#__PURE__*/_jsx("input", {
          type: "tel",
          className: "preview-control phone-preview-input",
          placeholder: field.placeholder || 'Phone number',
          disabled: true
        })]
      });
    case 'tags':
      return /*#__PURE__*/_jsx("div", {
        className: "tags-preview-container",
        children: /*#__PURE__*/_jsx("span", {
          className: "tags-preview-placeholder",
          children: "Tags..."
        })
      });
    case 'table':
      const tableColumnCount = field.columns?.length || 2;
      const tableRowCount = field.rows?.length || 1;
      const columns = field.columns || [];
      const tableFieldIds = field.sections || [];
      const tableFields = tableFieldIds && allFields.length > 0 ? tableFieldIds.map(id => allFields.find(f => f.id === id)).filter(f => f) : [];
      return /*#__PURE__*/_jsxs("div", {
        className: "table-preview-container",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "table-preview-label",
          children: [field.label || 'Table', " (", tableColumnCount, " columns, ", tableRowCount, " rows)", /*#__PURE__*/_jsxs("span", {
            className: "field-type-indicator",
            children: ["(", field.type, ")"]
          })]
        }), tableFields.length > 0 && /*#__PURE__*/_jsx("div", {
          className: "form-renderer-fields-container table-preview-fields-container",
          children: tableFields.map(f => {
            const widthClass = getColumnWidthClass(f.columnWidth || '1');
            return /*#__PURE__*/_jsxs("div", {
              className: `${widthClass} table-preview-field-item`,
              children: ["\u2022 ", f.label, " (", f.type, ")"]
            }, f.id);
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "table-preview-table-wrapper",
          children: /*#__PURE__*/_jsxs("table", {
            className: "table-preview-table",
            style: {
              borderWidth: field.borderWidth || '1px',
              borderColor: field.borderColor || '#d1d5db',
              borderStyle: 'solid',
              borderCollapse: 'collapse'
            },
            children: [/*#__PURE__*/_jsx("thead", {
              className: "table-preview-thead",
              children: /*#__PURE__*/_jsx("tr", {
                children: columns.map((col, idx) => /*#__PURE__*/_jsx("th", {
                  className: "table-preview-th",
                  style: {
                    borderWidth: field.borderWidth || '1px',
                    borderColor: field.borderColor || '#d1d5db',
                    borderStyle: 'solid'
                  },
                  children: col.label || `Column ${idx + 1}`
                }, idx))
              })
            }), /*#__PURE__*/_jsxs("tbody", {
              children: [field.rows?.slice(0, 3).map((row, rowIdx) => /*#__PURE__*/_jsx("tr", {
                children: columns.map((col, colIdx) => {
                  // Check for cell-specific configuration
                  const cells = col.cells || {};
                  const cellConfig = cells[row.id];
                  let cellContent = '-';
                  if (cellConfig && cellConfig.type === 'field') {
                    cellContent = 'Field';
                  }
                  return /*#__PURE__*/_jsx("td", {
                    className: "table-preview-td",
                    style: {
                      borderWidth: field.borderWidth || '1px',
                      borderColor: field.borderColor || '#d1d5db',
                      borderStyle: 'solid'
                    },
                    children: cellContent
                  }, colIdx);
                })
              }, row.id || rowIdx)), tableRowCount > 3 && /*#__PURE__*/_jsx("tr", {
                children: /*#__PURE__*/_jsxs("td", {
                  colSpan: tableColumnCount,
                  className: "table-preview-td-center",
                  style: {
                    borderWidth: field.borderWidth || '1px',
                    borderColor: field.borderColor || '#d1d5db',
                    borderStyle: 'solid'
                  },
                  children: ["... and ", tableRowCount - 3, " more rows"]
                })
              })]
            })]
          })
        })]
      });
    case 'tabs':
      const tabsFieldTabs = field.tabs || [{
        id: 'tab1',
        label: 'Tab 1'
      }];
      const tabsFieldTabContent = field.tabContent || {};
      // For preview, show fields from all tabs
      const allTabFieldIds = [];
      Object.values(tabsFieldTabContent).forEach(tabItems => {
        tabItems.forEach(item => {
          if (item.type === 'field' && !allTabFieldIds.includes(item.value)) {
            allTabFieldIds.push(item.value);
          }
        });
      });
      const tabsNestedFields = allTabFieldIds && allFields.length > 0 ? allTabFieldIds.map(id => allFields.find(f => f.id === id)).filter(f => f) : [];
      return /*#__PURE__*/_jsxs("div", {
        className: "tabs-preview-container",
        children: [(field.label || field.name) && /*#__PURE__*/_jsxs("div", {
          className: "tabs-preview-header",
          children: [field.label || field.name, /*#__PURE__*/_jsxs("span", {
            className: "field-type-indicator",
            children: ["(", field.type, ")"]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "tabs-preview-tabs",
          children: tabsFieldTabs.map((tab, idx) => /*#__PURE__*/_jsx("div", {
            className: `tabs-preview-tab ${idx === 0 ? 'active' : ''}`,
            children: tab.label
          }, tab.id))
        }), tabsNestedFields.length > 0 ? /*#__PURE__*/_jsx("div", {
          className: "tabs-preview-content",
          children: /*#__PURE__*/_jsx("div", {
            className: "form-renderer-fields-container",
            children: tabsNestedFields.map(f => {
              const widthClass = getColumnWidthClass(f.columnWidth || '1');
              return /*#__PURE__*/_jsxs("div", {
                className: `${widthClass} table-preview-field-item`,
                children: ["\u2022 ", f.label, " (", f.type, ")"]
              }, f.id);
            })
          })
        }) : /*#__PURE__*/_jsx("div", {
          className: "tabs-preview-empty",
          children: "No fields added"
        })]
      });
    default:
      return /*#__PURE__*/_jsx("input", {
        type: field.type,
        className: "preview-control",
        placeholder: field.placeholder,
        disabled: true
      });
  }
};

/**
 * Field Preview Component - Renders a preview of a field in the builder
 */
export const FieldPreview = _ref => {
  let {
    field,
    isSelected,
    onSelect,
    allFields = [],
    index,
    totalFields,
    onMoveUp,
    onMoveDown,
    onDuplicate,
    onDelete
  } = _ref;
  const widthClass = getColumnWidthClass(field.columnWidth || '1');

  // Helper to render nested fields for containers
  const renderNestedFieldsPreview = containerField => {
    // Use 'sections' for container fields
    const fieldIds = containerField.sections;
    if (!fieldIds || !Array.isArray(fieldIds)) {
      return null;
    }
    const nestedFields = fieldIds.map(fieldId => allFields.find(f => f.id === fieldId)).filter(f => f);
    if (nestedFields.length === 0) {
      return /*#__PURE__*/_jsx("div", {
        className: "preview-empty-message",
        children: "No fields assigned"
      });
    }
    return nestedFields.map(nestedField => /*#__PURE__*/_jsxs("div", {
      className: "preview-nested-field-item",
      children: [nestedField.label, " (", nestedField.type, ")"]
    }, nestedField.id));
  };

  // Render FieldActions if callbacks are provided
  const renderActions = () => {
    if (onMoveUp && onMoveDown && onDuplicate && onDelete && index !== undefined && totalFields !== undefined) {
      return /*#__PURE__*/_jsx(FieldActions, {
        field: field,
        index: index,
        totalFields: totalFields,
        onMoveUp: onMoveUp,
        onMoveDown: onMoveDown,
        onDuplicate: onDuplicate,
        onDelete: onDelete
      });
    }
    return null;
  };

  // Layout & Content fields
  if (field.type === 'divider') {
    return /*#__PURE__*/_jsxs("div", {
      className: `field-preview ${isSelected ? 'selected' : ''} ${widthClass}`,
      onClick: onSelect,
      children: [/*#__PURE__*/_jsx("div", {
        className: "field-preview-content",
        children: /*#__PURE__*/_jsx("hr", {
          className: "preview-divider"
        })
      }), renderActions()]
    });
  }
  if (field.type === 'heading') {
    const Tag = field.headingTag || 'h3';
    const fontSizeMap = {
      h1: '2rem',
      h2: '1.5rem',
      h3: '1.25rem',
      h4: '1.125rem',
      h5: '1rem',
      h6: '0.875rem'
    };
    return /*#__PURE__*/_jsxs("div", {
      className: `field-preview ${isSelected ? 'selected' : ''} ${widthClass}`,
      onClick: onSelect,
      children: [/*#__PURE__*/_jsx("div", {
        className: "field-preview-content",
        children: /*#__PURE__*/_jsx("div", {
          className: "preview-heading-wrapper",
          children: /*#__PURE__*/_jsxs(Tag, {
            className: `preview-heading-tag heading-field-tag-${Tag}`,
            children: [field.label || 'Heading', /*#__PURE__*/_jsxs("span", {
              className: "field-type-indicator-xs",
              children: ["(", field.type, ")"]
            })]
          })
        })
      }), renderActions()]
    });
  }
  if (field.type === 'paragraph') {
    const Tag = field.paragraphType || 'p';
    return /*#__PURE__*/_jsxs("div", {
      className: `field-preview ${isSelected ? 'selected' : ''} ${widthClass}`,
      onClick: onSelect,
      children: [/*#__PURE__*/_jsx("div", {
        className: "field-preview-content",
        children: /*#__PURE__*/_jsxs(Tag, {
          className: "preview-paragraph-tag",
          children: [field.label || 'Paragraph text', /*#__PURE__*/_jsxs("span", {
            className: "field-type-indicator-xs",
            children: ["(", field.type, ")"]
          })]
        })
      }), renderActions()]
    });
  }
  if (field.type === 'hidden') {
    return /*#__PURE__*/_jsxs("div", {
      className: `field-preview ${isSelected ? 'selected' : ''} ${widthClass}`,
      onClick: onSelect,
      children: [/*#__PURE__*/_jsx("div", {
        className: "field-preview-content",
        children: /*#__PURE__*/_jsx("div", {
          className: "preview-hidden-field",
          children: "Hidden Field"
        })
      }), renderActions()]
    });
  }
  if (field.type === 'repeater') {
    const repeaterFields = field.fields || [];
    return /*#__PURE__*/_jsxs("div", {
      className: `field-preview ${isSelected ? 'selected' : ''} ${widthClass}`,
      onClick: onSelect,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "field-preview-content",
        children: [/*#__PURE__*/_jsxs("label", {
          className: "preview-label",
          children: [field.label, /*#__PURE__*/_jsxs("span", {
            className: "field-type-indicator",
            children: ["(", field.type, ")"]
          }), field.required && /*#__PURE__*/_jsx("span", {
            className: "required-indicator",
            children: " *"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "preview-repeater-container",
          children: [repeaterFields.length > 0 ? /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: "preview-repeater-item-label",
              children: "Item 1 (Preview)"
            }), repeaterFields.map((subField, idx) => /*#__PURE__*/_jsxs("div", {
              className: "preview-repeater-subfield",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "preview-repeater-subfield-label",
                children: [subField.label || 'Field', " (", subField.type, ")", subField.required && /*#__PURE__*/_jsx("span", {
                  className: "required-indicator",
                  children: " *"
                })]
              }), renderFieldInput(subField, allFields)]
            }, subField.id || idx))]
          }) : /*#__PURE__*/_jsx("div", {
            className: "preview-repeater-empty",
            children: "No fields configured"
          }), /*#__PURE__*/_jsx("div", {
            className: "preview-repeater-add-btn",
            children: "+ Add Item"
          })]
        }), field.helpText && /*#__PURE__*/_jsx("div", {
          className: "preview-help-text",
          children: field.helpText
        })]
      }), renderActions()]
    });
  }

  // Regular input fields
  return /*#__PURE__*/_jsxs("div", {
    className: `field-preview ${isSelected ? 'selected' : ''} ${widthClass}`,
    onClick: onSelect,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "field-preview-content",
      children: [/*#__PURE__*/_jsxs("label", {
        className: "preview-label",
        children: [field.label, /*#__PURE__*/_jsxs("span", {
          className: "field-type-indicator",
          children: ["(", field.type, ")"]
        }), field.required && /*#__PURE__*/_jsx("span", {
          className: "required-indicator",
          children: " *"
        })]
      }), renderFieldInput(field, allFields), field.helpText && /*#__PURE__*/_jsx("div", {
        className: "preview-help-text",
        children: field.helpText
      })]
    }), renderActions()]
  });
};